import Image from 'components/common/Image';
import { Box, Text } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import { LinkItem } from 'modules/root/components/LinkItem';
import React from 'react';
import { useNavigate } from 'react-router';
import { Asset, AssetType } from 'types';
import { formatDate } from 'utils/stringUtils';

const SmallCard = ({
  image,
  label,
  createdAt,
  shortid,
  route,
  type,
}: Asset & { route: string }) => {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  return (
    <Box direction="column" animation="fadeIn" pad="medium" gap="small">
      {!isMobile && (
        <Box
          pad={{ bottom: 'medium' }}
          onClick={() => navigate(`${route}/${shortid}`)}
          width={{ max: '600px' }}
        >
          <Image src={image} fit="cover" />
        </Box>
      )}
      <LinkItem
        color="black"
        route={`${route}/${shortid}`}
        linkStyle={{ whiteSpace: 'none' }}
      >
        <Text weight="bold">{label}</Text>
      </LinkItem>
      {type === AssetType.NEWS && (
        <Text size="small">{formatDate(createdAt)}</Text>
      )}
    </Box>
  );
};

export default SmallCard;
